import React from 'react'
import { ImpactStoriesSection } from '@pw-tech/omni-ui'

export interface ImageData {
  id: number
  frontImage: string
  backImage: string
  altFront: string
  altBack: string
  customClass: string
}

export interface StaticImage {
  src?: string
  alt?: string
  className?: string
}

export interface ImpactStoriesProps {
  heading: string
  images: ImageData[]
  staticImages: StaticImage[]
}

export const ImpactStoriesSectionWidget: React.FC<ImpactStoriesProps> = ({
  images,
  staticImages,
  heading,
}) => {
  return (
    <ImpactStoriesSection
      images={images}
      staticImages={staticImages}
      heading={heading}
    />
  )
}
